import { AssigneeInput } from '@components/AssigneeInput/AssigneeInput';
import { addKnownUser } from '@store/redux/features/inventory/knownData';
import { RootState, useAppDispatch } from '@store/redux/store';
import { pick } from '@utils/pick';
import { useSelector } from 'react-redux';
import { memo } from 'react';
import {
  AssigneeWrapper,
  BigInputDiv,
  GlobalHeader,
  InputList,
} from '../styles';
import { PropsInputGlobal } from './types';
import { onChangeGlobal, setForAllNew } from './utils';

type AssigneeGroupProps = PropsInputGlobal<'userId'>;

export function AssigneeGroup(props: AssigneeGroupProps) {
  const { setFormV, userId, setGlobalFormV } = props;

  const knownUser = useSelector(
    (state: RootState) => state.knownData.knownUsers[userId ?? ''] || null,
  );
  const dispatch = useAppDispatch();
  return (
    <InputList>
      <BigInputDiv>
        <GlobalHeader>Assignee</GlobalHeader>
        <AssigneeWrapper>
          <AssigneeInput
            borderColor="#d8dae5"
            width={338}
            handleUserChange={user => {
              if (user === null || user === undefined) {
                onChangeGlobal('userId', null, setGlobalFormV);
                setForAllNew('userId', null, setFormV);
                return;
              }

              dispatch(addKnownUser(pick(user, ['id', 'name'])));

              onChangeGlobal('userId', user.id, setGlobalFormV);
              setForAllNew('userId', user.id, setFormV);
            }}
            value={knownUser}
          />
        </AssigneeWrapper>
      </BigInputDiv>
    </InputList>
  );
}
export default memo(AssigneeGroup);
